import type { FarmQuantificationUnit } from '@/types/apiModels'

export function derivePaddockCount(qu: FarmQuantificationUnit): number {
  return qu.paddocksByYear[qu.baselineYear]?.length ?? 0
}
